import {FC, useCallback} from 'react'
import {useDeleteSubClientMutation} from '../../../../../services/cellcast.v2'
import {Button, Modal} from 'react-bootstrap'
import {toast} from 'react-toastify'

export type DeleteUserProps = {
  deletedId: string
  show: boolean
  message: string
  description?: string
  confirmBtnTitle?: string
  handleClose: () => void
  callbackFn: () => void
}

const DeleteUser: FC<DeleteUserProps> = (props) => {
  const {deletedId, show, message, description, confirmBtnTitle, handleClose, callbackFn} = props
  const [deleteUser, {isLoading}] = useDeleteSubClientMutation()
  const handleDelete = useCallback(() => {
    if (!deletedId || (deletedId && deletedId === '')) {
      return
    }
    
    deleteUser({
      id: deletedId,
    })
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
          if (callbackFn) {
            callbackFn()
          }
        } else if ('error' in res) {
          toast.error(res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  }, [deletedId])

  return (
    <Modal show={show} onHide={handleClose} dialogClassName='modal-dialog-centered'>
      <div className='modal-header text-center no-border pt-10'>
        <div className='icon-box col-12'>
          <i className={`fa red-circle yellow-circle fa-exclamation`}></i>
        </div>
        {/* <h2></h2> */}
      </div>
      <div className='modal-body text-center fs-3'>{message}</div>
      {description && <div className='px-2 text-center fs-5'>{description}</div>}

      <div className='modal-footer'>
        <Button color='danger' className='btn-danger delete-success-btn' onClick={handleDelete}>
          {isLoading ? 'processing ....' : confirmBtnTitle ? confirmBtnTitle : 'Yes, Delete!'}
        </Button>
        <Button
          color='black'
          className='delete-cancel-btn'
          style={{background: 'transparent', color: 'black'}}
          onClick={handleClose}
        >
          No, Cancel
        </Button>{' '}
      </div>
    </Modal>
  )
}

export default DeleteUser
